module.exports = __webpack_public_path__ + "static/fb-15f02966f71b44756592a6360d3ca2ee.png";